import { render, staticRenderFns } from "./TimeOffCalendarEvent.vue?vue&type=template&id=088623c0&"
import script from "./TimeOffCalendarEvent.vue?vue&type=script&lang=ts&"
export * from "./TimeOffCalendarEvent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports